<template>
  <a-button-group>
    <a-tooltip :title="t('propsEditor.allUpperCase')">
      <a-button @click="$emit('component-event', { name: 'uppercase', config })"
        ><img src="@/assets/icons/uppercase.svg" alt=""
      /></a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.allLowerCase')">
      <a-button @click="$emit('component-event', { name: 'lowercase', config })"
        ><img src="@/assets/icons/lowercase.svg" alt=""
      /></a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.wordFirstLetterUppercase')">
      <a-button @click="$emit('component-event', { name: 'wordFirstLetterUppercase', config })"
        >{{ t('propsEditor.word') }}<img src="@/assets/icons/first-letter-uppercase.svg" alt=""
      /></a-button>
    </a-tooltip>
    <a-tooltip :title="t('propsEditor.sentenceFirstLetterUppercase')">
      <a-button @click="$emit('component-event', { name: 'sentenceFirstLetterUppercase', config })"
        >{{ t('propsEditor.sentence') }}<img src="@/assets/icons/first-letter-uppercase.svg" alt=""
      /></a-button>
    </a-tooltip>
  </a-button-group>
</template>

<script setup>
import { props as commonProps } from './helper';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
defineProps({ ...commonProps });
const emit = defineEmits(['component-event']);
</script>

<style lang="less" scoped></style>
